// test js compatibilities
function animSupported () {
    let el = document.createElement('div')
    let transEndEventNames = ['transition', 'WebkitTransition', 'MozTransition', 'OTransition']
    for (let name of transEndEventNames) {
        if (typeof (el.style)[name] != 'undefined') {
            return true
        }
    }
    return false
}

function canvasSupported () {
    let canvas = document.createElement('canvas')
    return !!(canvas.getContext && canvas.getContext('2d'))
}

function webglSupported () {
    try {
        let canvas = document.createElement('canvas')
        return !!(window.WebGLRenderingContext && (
            canvas.getContext('webgl') ||
            canvas.getContext('experimental-webgl'))
        )
    } catch (e) {
        return false
    }
}

function rafSupported () {
    let vendors = ['ms', 'moz', 'webkit', 'o']
    for (let i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
        window.requestAnimationFrame = (window)[vendors[i] + 'RequestAnimationFrame']
        window.cancelAnimationFrame = (window)[vendors[i] + 'CancelAnimationFrame'] || (window)[vendors[i] + 'CancelRequestAnimationFrame']
    }

    return !!(window.requestAnimationFrame)
}

let raf = rafSupported()
// Add Polyfills
if (!raf) {
    let lastTime = 0
    window.requestAnimationFrame = function(callback) {
        var currTime = new Date().getTime()
        var timeToCall = Math.max(0, 16 - (currTime - lastTime))
        var id = window.setTimeout(function () {
            callback(currTime + timeToCall)
        }, timeToCall)
        lastTime = currTime + timeToCall
        return id
    }
    window.cancelAnimationFrame = function (id) {
        clearTimeout(id)
    }
}

export default {
    animSupported: animSupported(),
    canvasSupported: canvasSupported(),
    webglSupported: webglSupported(),
    rafSupported: raf
}
